import { useEffect } from "react";
import RouterRender from "./router/index";
import FontSetting from "./styles/FontSetting";

function App() {
  const currentTheme = require(
    `./theme/${process.env.REACT_APP_PRODUCTION_NAME_DEV}/theme.json`,
  );
  const defaultTheme = require(`./theme/defaultTheme.json`);
  const finalTheme = { ...defaultTheme, ...currentTheme };

  const setTheme = () => {
    const r: any = document.querySelector(":root");
    const final = Object.entries(finalTheme);
    final.map((color) => {
      r?.style?.setProperty(color[0], color[1]);
    });
  };
  const initStyle = () => {
    const _vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${_vh}px`);
  };

  useEffect(() => {
    initStyle();
    setTheme();
    // 手機旋轉、瀏覽器 UI 顯示/隱藏時更新 --vh，避免底部黑條
    window.addEventListener("resize", initStyle);
    window.visualViewport?.addEventListener("resize", initStyle);
    return () => {
      window.removeEventListener("resize", initStyle);
      window.visualViewport?.removeEventListener("resize", initStyle);
    };
  }, []);

  /**
   * SCROLL TESTING PURPOSE
   * DO NOT DELETE, OPEN WHEN DEBUG SCROLL ISSUE ONLY
   */
  // function isScrollable(el: any) {
  //   return el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
  // }
  // window.addEventListener(
  //   "scroll",
  //   function (e: any) {
  //     var el: any = e.target;
  //     while (el && el !== document && !isScrollable(el)) {
  //       el = el?.parent;
  //     }
  //     console.debug("Scrolled element: " + (el?.className || "document"));
  //   },
  //   true
  // );

  return (
    <div>
      <FontSetting />
      <RouterRender />
    </div>
  );
}

export default App;
